import { render, staticRenderFns } from "./AccountInvestigationClosedCard.vue?vue&type=template&id=caacef12&scoped=true&"
import script from "./AccountInvestigationClosedCard.vue?vue&type=script&lang=js&"
export * from "./AccountInvestigationClosedCard.vue?vue&type=script&lang=js&"
import style0 from "./AccountInvestigationClosedCard.vue?vue&type=style&index=0&id=caacef12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caacef12",
  null
  
)

export default component.exports